// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "map/css/" + "text-editor" + "." + "6f2f7175" + ".css";
};